module.exports = __webpack_public_path__ + "static/media/topup_view.53421c71.svg";